import { Check } from "lucide-react";

/** The 7 steps of a recording, each lit when done. Steps 1–2 reopen setup; the rest jump to their panel. */
export default function StepStrip({ steps, onStep }) {
  return (
    <ol data-testid="rec-steps" className="flex flex-wrap gap-1.5">
      {steps.map((s, i) => (
        <li key={s.key}>
          <button type="button" data-testid={`rec-step-${s.key}`} data-done={s.done ? "1" : "0"} onClick={() => onStep(s)}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.14em] transition-colors duration-200 ${s.done ? "border-emerald-300/40 bg-emerald-500/10 text-emerald-100" : "border-white/10 text-white/55 hover:text-white"}`}>
            {s.done ? <Check className="h-3 w-3" /> : <span className="text-white/40">{i + 1}</span>} {s.label}
          </button>
        </li>
      ))}
    </ol>
  );
}
